import { NgModule } from '@angular/core';

import { SharedModule } from '../../../../../../shared';
import { NgxBootstrapMultiselectModule } from 'ngx-bootstrap-multiselect';

import { ClienteAnaliseFinanceiraStatusMultiselectComponent } from './cliente-analise-financeira-status-multiselect.component';

@NgModule({
    imports: [
        SharedModule,
        NgxBootstrapMultiselectModule
    ],
    declarations: [
        ClienteAnaliseFinanceiraStatusMultiselectComponent
    ],
    exports: [
        ClienteAnaliseFinanceiraStatusMultiselectComponent
    ]
})
export class ClienteAnaliseFinanceiraStatusMultiselectModule { }
